/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useContext, useCallback } from 'react';
import Space from '@/components/Space';
import TextEditor from '../../utils/TextEditor';
import useApi from '@/lib/api/useApi';
import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import { type LogEntry, type LogEntryWithoutFiles } from '@/lib/types';

type LogEntryEditorProps = {
  logEntry: LogEntry;
  onClose: () => void;
};

// TODO maybe texteditor can handle saving state itself by awaiting onSave()?
const LogEntryEditor = ({ logEntry, onClose }: LogEntryEditorProps) => {
  const api = useApi();

  const { setPortfolioItem, portfolioItemApiEndpoint } =
    useContext(PortfolioItemContext);

  const [saving, setSaving] = useState(false);

  const handleSave = useCallback(
    async (value: string | null): Promise<void> => {
      setSaving(true);

      const updatedLogEntry = await api.put<LogEntryWithoutFiles>(
        `${portfolioItemApiEndpoint}/log-entries/${logEntry.id}`,
        {
          content: value ?? '',
        },
      );

      setPortfolioItem(portfolioItem => {
        portfolioItem.logEntries[logEntry.id] = {
          ...portfolioItem.logEntries[logEntry.id],
          ...updatedLogEntry,
        };
      });

      setSaving(false);
      onClose();
    },
    [],
  );

  return (
    <>
      <Space height={18} />
      <TextEditor
        initialValue={logEntry.content}
        onCancel={onClose}
        onSave={handleSave}
        disabled={saving}
      />
    </>
  );
};

export default LogEntryEditor;
